import React from 'react';
import { TileLayer, LayersControl } from 'react-leaflet';

const { BaseLayer } = LayersControl;

export default function LeafletBaseLayers() {
    return (
        <LayersControl position="topright">
            <BaseLayer checked name="Street">
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='© OpenStreetMap'
                    maxZoom={19}
                />
            </BaseLayer>
            <BaseLayer name="Satellite">
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                    attribution='© Esri'
                />
            </BaseLayer>
            <BaseLayer name="Topo">
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
                    attribution="© Esri"
                />
            </BaseLayer>
        </LayersControl>
    );
}
